import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 30 minutes of inactivity

function InactivityDetector() {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  useEffect(() => {
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    const handleActivity = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        localStorage.setItem('authError', 'Votre session a expiré suite à une période d\'inactivité.');
        localStorage.removeItem('token');
        navigate('/');
      }, INACTIVITY_TIMEOUT);
    };

    // Start the initial timer
    handleActivity();
    // Attach listeners
    events.forEach(event => window.addEventListener(event, handleActivity));

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(event => window.removeEventListener(event, handleActivity));
    };
  }, [navigate]);

  return null;
}

export default InactivityDetector;